<template>
<div class="ecology-banner">
  <div class="content">
    <h2>中软国际开源鸿蒙创新实验室</h2>
    <p>包含开源鸿蒙创新测试实验室、全系感知城市生命线模拟测试环境实验室</p>
<!--    <a-button class="btn-red btn-box">了解详情</a-button>-->
  </div>
</div>
</template>

<script>
export default {

}
</script>


<style scoped lang="scss">
.ecology-banner{
  background: url("../../../assets/img/2.0/ecology/bg.png") no-repeat;
  background-size: cover;
  height: 430px;
  width: 100%;
  .content{
    width: 1280px;
    margin: 0 auto;
    padding: 123px 0;
    >h2{
      font-weight: bold;
      font-size: 40px;
      color: #262626;
      line-height: 56px;
      margin-bottom: 16px;
    }
    >p{
      font-weight: 400;
      font-size: 24px;
      color: #262626;
      line-height: 32px;
      margin-bottom: 40px;
    }
    .btn-box{
      width: 136px;
      height: 40px;
      font-weight: 400;
      font-size: 18px;
      color: #FFFFFF;
    }
  }
}
</style>
